
namespace Matrix.Indexation {

    @Serenity.Decorators.registerClass()
    export class PriceTypeGrid extends SiteEntityGrid<PriceTypeRow, any> {
        protected getColumnsKey() { return PriceTypeColumns.columnsKey; }
        protected getDialogType() { return PriceTypeDialog; }
        protected getIdProperty() { return PriceTypeRow.idProperty; }
        protected getInsertPermission() { return PriceTypeRow.insertPermission; }
        protected getLocalTextPrefix() { return PriceTypeRow.localTextPrefix; }
        protected getService() { return PriceTypeService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}